import api from './api';
import { fetchPage } from './pagedParams';

const orderService = {
    getOrders: async () => (await api.get('/admin/orders')).data,
    getOrderById: async (id) => (await api.get(`/admin/orders/${id}`)).data,
    getOrdersByCustomer: async (customerId) => (await api.get(`/admin/orders/by-customer/${customerId}`)).data,
    createOrder: async (data) => (await api.post('/admin/orders', data)).data,
    updateDraftOrder: async (id, data) => (await api.put(`/admin/orders/${id}`, data)).data,
    updateStatus: async (id, status, note) => (await api.patch(`/admin/orders/${id}/status`, null, {
        params: note ? { status, note } : { status },
    })).data,
    updatePaymentStatus: async (id, paymentStatus) =>
        (await api.patch(`/admin/orders/${id}/payment-status?paymentStatus=${paymentStatus}`)).data,

  // Server-side paged list (Spring Page) for the URL-driven DataTable.
  getOrdersPage: (params) => fetchPage('/admin/orders/paged', params),

};

export default orderService;
